import script from "./NextIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./NextIcon.vue?vue&type=script&setup=true&lang=ts"

import "./NextIcon.vue?vue&type=style&index=0&id=0f1fa656&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1fa656"]])

export default __exports__